import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./ErrorPages.css";

const NotFound = () => {
    const navigate = useNavigate();
    const [role, setRole] = useState<string | null>(null);

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                setRole(user.role);
            } catch (e) {
                console.error("Failed to parse user from localStorage", e);
            }
        }
    }, []);

    const handleGoHome = () => {
        if (role === "admin") {
            navigate("/dashboard");
        } else {
            navigate("/applicant/home");
        }
    };

    return (
        <div className="error-container">
            <h1 className="error-code">404</h1>
            <h2 className="error-title">Page Not Found</h2>
            <p className="error-message">
                The page you are looking for does not exist.
            </p>

            <button className="error-button" onClick={handleGoHome}>
                Go Back Home
            </button>
        </div>
    );
};

export default NotFound;